import Link from '@tiptap/extension-link';

/** 保留社区 App 跳转链接；编辑时点击链接只编辑，不跳离当前页面。 */
export const EditorLink = Link.configure({
    protocols: ['vivoclub', 'vivo', 'iqoo'],
    openOnClick: false,
});
